import { createAction, props } from '@ngrx/store';
import { PrintOrganismePayload } from './organismes.payloads';
export const printOrganisme = createAction(
  '[Organisme] Print',
  props<PrintOrganismePayload>()
);
